import * as React from "react";
import {useCallback, useEffect, useState} from "react";
import {
    classNames,
    layout,
    TabBar,
    TabItem,
    View,
    ViewContent
} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {OverviewTab} from "./OverviewTab";
import {BoxTab} from "./BoxTab";
import {Box} from "@variocube/app-api";
import {useLocalization} from "../../i18n";

export interface AdminViewProps {
    onOpenBox: (box: Box) => void;
    onDone: () => void;
}

enum AdminTab {
    Overview,
    Boxes
}

export function AdminHomeView({onOpenBox, onDone}: AdminViewProps) {
    const {t} = useLocalization();
    const [active, setActive] = useState<AdminTab>(AdminTab.Overview);

    const handleOverviewClick = useCallback(() => setActive(AdminTab.Overview), []);
    const handleBoxesClick = useCallback(() => setActive(AdminTab.Boxes), []);

    return (
        <View className={layout.vertical}>
            <div className={classNames(layout.fixed, layout.horizontal)}>
                <TabBar className={layout.fill}>
                    <TabItem active={active == AdminTab.Overview} onClick={handleOverviewClick}>
                        Overview
                    </TabItem>
                    <TabItem active={active == AdminTab.Boxes} onClick={handleBoxesClick}>
                        Boxes
                    </TabItem>
                </TabBar>
                <div className={styles.doneButton} onClick={onDone}>
                    <div>{t("Logout")}</div>
                </div>
            </div>
            <ViewContent>
                {active == AdminTab.Overview && (
                    <OverviewTab />
                )}
                {active == AdminTab.Boxes && (
                    <BoxTab onOpen={onOpenBox} />
                )}
            </ViewContent>
        </View>
    )
}


const styles = stylesheet({
    tabContent: {
        padding: "0.75em",
    },
    doneButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.25rem 0.75rem",
        background: "var(--color-primary)",
        color: "#fff",
        textTransform: "uppercase",
        fontWeight: 500,
        fontSize: "1.25em",
    }
});
